import React from "react";
import { DialogContentText, Typography, DialogTitle, Stack, IconButton } from "@mui/material";
import ModalLayout from "./Layout";
import ModalLayoutContent from "./Layout/Content";
import ModalLayoutFooter from "./Layout/Footer";
import ModalLayoutBtn from "./Layout/Btn";
import { X, Play, RefreshCw } from "react-feather";

/**
 * Modal for triggering DAG from failure
 * @param {{
 *  isShown: boolean;
 *  onHide: () => void;
 *  onTriggerFull: () => void;
 *  onTriggerFromFailure: () => void;
 *  workflowName: string;
 * }} props
 */
const TriggerFromFailureModal = ({
  isShown,
  onHide,
  onTriggerFull,
  onTriggerFromFailure,
  workflowName,
}) => {
  return (
    <ModalLayout 
      isShown={isShown} 
      onHide={onHide}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
          overflow: "hidden",
          background: "linear-gradient(to bottom, #ffffff, #f8f9fa)",
          border: "1px solid rgba(0,0,0,0.08)",
          transition: "all 0.3s ease-in-out"
        }
      }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        position={"relative"}
        padding={"16px 24px"}
        borderBottom={"1px solid rgba(0,0,0,0.05)"}
        sx={{ background: "rgba(241,250,255,0.4)" }}
      >
        <DialogTitle
          padding={"0 !important"}
          sx={{
            color: "#1976d2",
            fontWeight: 800,
            fontSize: "11px",
            display: "flex",
            alignItems: "center",
            "::before": {
              content: '""',
              display: "inline-block",
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "#1976d2",
              marginRight: "10px",
              animation: "pulse 1.5s infinite",
              "@keyframes pulse": {
                "0%": { boxShadow: "0 0 0 0 rgba(25, 118, 210, 0.7)" },
                "70%": { boxShadow: "0 0 0 10px rgba(25, 118, 210, 0)" },
                "100%": { boxShadow: "0 0 0 0 rgba(25, 118, 210, 0)" }
              }
            }
          }}
        >
          Trigger Options
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onHide}
          sx={{
            position: "absolute",
            right: 16,
            top: 10,
            color: "#495057",
            "&:hover": {
              background: "rgba(0,0,0,0.05)",
              transform: "rotate(90deg)",
              transition: "transform 0.3s ease"
            }
          }}
        >
          <X size={16} />
        </IconButton>
      </Stack>
      
      <ModalLayoutContent sx={{ padding: "24px 28px" }}>
        <DialogContentText
          textAlign={"center"}
          color="#4a4a4a"
          sx={{ fontSize: "11px", lineHeight: 1.6 }}
        >
          The last run of{" "}
          <Typography
            component={"span"}
            fontWeight={700}
            sx={{ 
              fontSize: "11px",
              color: "#1d3557",
              background: "rgba(241,250,255,0.8)",
              padding: "2px 6px",
              borderRadius: "4px",
              border: "1px solid rgba(0,123,255,0.2)"
            }}
          >
            {workflowName}
          </Typography>
          {" "}failed.
          <br />
          <br />
          How would you like to trigger this DAG?
          <br />
          <Typography
            component="span"
            sx={{ 
              fontSize: "10px", 
              lineHeight: 1.4,
              fontStyle: "italic",
              color: "#6c757d",
              display: "block",
              marginTop: "4px"
            }}
          >
            Note: Skipped taps may rerun if their data is no longer fresh
          </Typography>
        </DialogContentText>
      </ModalLayoutContent>
      <ModalLayoutFooter sx={{ padding: "16px 24px", gap: "12px" }}>
        <ModalLayoutBtn 
          color="default"
          onClick={onTriggerFull}
          sx={{
            fontSize: "11px",
            borderRadius: "8px",
            fontWeight: 600,
            textTransform: "none",
            padding: "8px 20px",
            transition: "all 0.2s",
            color: "#5a6268",
            background: "linear-gradient(45deg, #f5f5f5, #e9ecef)",
            border: "1px solid #dee2e6",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              background: "linear-gradient(45deg, #e9ecef, #dee2e6)",
            }
          }}
        >
          <Play size={16} style={{ marginRight: "6px" }} /> Trigger Full DAG
        </ModalLayoutBtn>
        <ModalLayoutBtn 
          color="primary"
          onClick={onTriggerFromFailure}
          sx={{
            fontSize: "11px",
            borderRadius: "8px",
            fontWeight: 600,
            textTransform: "none",
            padding: "8px 16px",
            transition: "all 0.2s",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 4px 8px rgba(25,118,210,0.25)"
            }
          }}
        >
          <RefreshCw size={16} style={{ marginRight: "6px" }} /> Run from Failure
        </ModalLayoutBtn>
      </ModalLayoutFooter>
    </ModalLayout>
  );
};

export default TriggerFromFailureModal;